import { Controller } from "@hotwired/stimulus";

import { registerProbe } from "~/lib/web/scrub";

/** Fraction of the viewport height a section has to span to be the match. */
const PROBE = 0.5;

export default class WebThemeController extends Controller<HTMLElement> {
  private current = "";
  private unregister: (() => void) | null = null;

  override connect(): void {
    this.unregister = registerProbe<string>({
      read: (viewportHeight) => {
        // Queried every frame rather than cached, so sections added after
        // connect() are included.
        const sections = this.element.querySelectorAll("[data-theme-section]");
        const probe = viewportHeight * PROBE;
        // The last match is used. Sections are in document order, so where two
        // overlap because one is pinned with position: sticky, the later one is
        // on top.
        let theme = "light";
        for (const section of sections) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= probe && rect.bottom > probe) {
            theme =
              section.getAttribute("data-theme-section") === "dark"
                ? "dark"
                : "light";
          }
        }
        return theme;
      },
      write: (theme) => {
        if (theme === this.current) return;
        this.current = theme;
        this.element.setAttribute("data-theme", theme);
      },
    });
  }

  override disconnect(): void {
    this.unregister?.();
    this.unregister = null;
    this.current = "";
  }
}
